<div
  class="simple-grid grid"
  [style.marginTop.px]="marginService.getCurrentMargin(margin)"
>
  <div
    *ngFor="let block of section.blocks"
    class="grid__item"
    [ngClass]="[
      'col-' + block.columnFrom + '-' + block.columnTo,
      'row-' + block.rowFrom + '-' + block.rowTo
    ]"
  >
    <app-img
      [src]="block.imageLink"
      [width]="block.imageWidth"
      [height]="block.imageHeight"
      [options]="{
        fillCrop: true
      }"
    ></app-img>
  </div>
</div>
